import { Navigate } from 'react-router-dom'

export const SubscriptionsPage = () => <Navigate to="/mealplan" replace />
